import { Path } from '@/main/router/routerPath';

import ObchPripList from './pages/ObchodniPripadList.vue';
import ArchyvDokladuList from './pages/ArchyvDokladuList.vue';
import NabidkyList from './pages/NabidkyList.vue';
import { ProdejNovychVozu } from './prodejNovychVozu';
import { SkladNovychVozu } from './skladNovychVozu';

export const router = new Path('NoveVozy').addChildren([
	new Path('ObchPrip', { List: ObchPripList }, 'CRM_ObchPripady'),
	new Path('ArchyvDokladu', { List: ArchyvDokladuList }, 'NV_ArchivDokl'),
	new Path('Nabidky', { List: NabidkyList }, 'NV_Nabidky'),

	ProdejNovychVozu.router,
	SkladNovychVozu.router,
]);
